export const basic = (size, weight, color, height) => {
    return {
        fontSize: size,
        fontWeight: weight || "normal",
        color: color || "black",
        lineHeight: height || "normal",
    };
};
